<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
  <router-outlet></router-outlet>
    <app-footer></app-footer>
         <div class="spinner" *ngIf="routerChanged">
         <div class="bounce1"></div>
         <div class="bounce2"></div>
         <div class="bounce3"></div>
      </div>
     </div>  